import { setSpecificMessage, graphemes } from "valibot";
setSpecificMessage(
  graphemes,
  (issue) => `Graphèmes invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);